"use client";

import styled from "@emotion/styled";
import { Step, StepLabel } from "@mui/material";

export const StyledStepLabel = styled(StepLabel)`
  & .MuiSvgIcon-root {
    height: 40px;
    width: 40px;

    @media (max-width: 600px) {
      height: 24px;
      width: 24px;
    }
  }

  & .MuiStepIcon-text {
    display: block;
    fill: #6b7280;

    @media (max-width: 600px) {
      font-size: 0.6rem;
    }
  }

  & .MuiSvgIcon-root.Mui-active .MuiStepIcon-text {
    fill: #fff;
  }

  & .MuiStepLabel-label.Mui-completed {
    color: #2e7d32;
    font-size: 14px;
    font-weight: 500;
    opacity: 1;

    @media (max-width: 600px) {
      font-size: 12px;
    }
  }

  & .MuiStepLabel-label {
    margin-top: 10px !important;
    font-size: 14px;

    @media (max-width: 600px) {
      font-size: 10px;
      white-space: nowrap;
    }
  }
`;

export const StyledStep = styled(Step)`
  & .MuiStepConnector-root.Mui-active .MuiStepConnector-line {
    border-color: #2e7d32;
    opacity: 1;
  }

  & .MuiStepConnector-line {
    border: 2px solid;
    border-color: #6b7280;
    opacity: 0.6;
    transform: translateY(150%);
    border-radius: 0;

    @media (max-width: 600px) {
      transform: translateY(100%); /* Adjust for better mobile alignment */
    }
  }
`;
